import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';
import { QuestionStructureInformation } from '../../../core/models/question/question-information.model';
import { Question } from '../../../core/models/question/question.model';

@UntilDestroy()
@Component({
  selector: 'lib-question-information',
  templateUrl: './question-information.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./question-information.component.scss'],
  standalone: false,
})
export class QuestionInformationComponent implements OnInit {
  private infoContainerRef: ElementRef;
  @ViewChild('infoContainer', { static: false }) set content(
    content: ElementRef,
  ) {
    // initially setter gets called with undefined
    if (content) {
      this.infoContainerRef = content;
      if (this.showOrHideInformationValue === '2') {
        this.renderer.setStyle(
          this.infoContainerRef.nativeElement,
          'height',
          `${this.collapsedHeight}rem`,
        );
        this.addOrRemoveFading('add');
      }
    }
  }
  @Input()
  question: Question;
  @Input() repeaterGroupId: string;

  isCollapsed = true;
  label: string;
  height: number;
  collapsedHeight = 6.5625;
  activeLang$: Observable<string>;

  showOrHideQuestion() {
    if (this.showOrHideInformationValue === '2') {
      this.height = this.infoContainerRef.nativeElement.querySelector(
        '#' + 'infoAccordion-' + this.question.id,
      ).offsetHeight;
      if (this.isCollapsed) {
        this.renderer.setStyle(
          this.infoContainerRef.nativeElement,
          'height',
          `${this.height}px`,
        );
        this.addOrRemoveFading('remove');
      } else {
        this.renderer.setStyle(
          this.infoContainerRef.nativeElement,
          'height',
          `${this.collapsedHeight}rem`,
        );
        this.addOrRemoveFading('add');
      }
    }
    this.isCollapsed = !this.isCollapsed;
  }

  addOrRemoveFading(addOrRemove: string) {
    if (addOrRemove === 'add') {
      if (this.repeaterGroupId) {
        this.infoContainerRef.nativeElement.classList.add('fading-repeater');
      } else {
        this.infoContainerRef.nativeElement.classList.add('fading');
      }
    } else {
      if (this.repeaterGroupId) {
        this.infoContainerRef.nativeElement.classList.remove('fading-repeater');
      } else {
        this.infoContainerRef.nativeElement.classList.remove('fading');
      }
    }
  }

  get textContent() {
    return this.question.structure.description;
  }
  get showOrHideInformationValue() {
    return (this.question.structure as QuestionStructureInformation)
      .showOrHideInformation;
  }

  constructor(
    private cdr: ChangeDetectorRef,
    private translocoService: TranslocoService,
    private renderer: Renderer2,
  ) {}

  ngOnInit() {
    this.activeLang$ = this.translocoService.langChanges$;
    this.translocoService.langChanges$
      .pipe(untilDestroyed(this))
      .subscribe(() => this.cdr.markForCheck());
  }
}
